import React from 'react'
import clsx from 'clsx'

import { MenuFooterHeaderProps } from './FooterMenu.types'
import styles from './FooterMenu.module.scss'
import Icon from '@/components/atoms/Icon'

const MenuFooterHeader = ({
  isOpen,
  headerLabel,
  mainExists = true,
  collapsable = true,
  collapsableLabel = null,
  onButtonClick,
}: MenuFooterHeaderProps) => (
  <header className={clsx(styles.footerMenuHeader)}>
    <span className={clsx(styles.footerMenuHeaderLink)}>{headerLabel}</span>

    {collapsable && mainExists && (
      <button
        className={clsx(styles.footerMenuHeaderButton, isOpen && styles.open)}
        onClick={onButtonClick}
        aria-label={collapsableLabel ? collapsableLabel : ''}
      >
        <Icon iconName={'ChevronDown'} />
      </button>
    )}
  </header>
)

export default MenuFooterHeader
